export default () => {

  window.google.maps.Map.prototype.getGeoJson = function(){
    var geo = {
      "type": "FeatureCollection",
      "features": []
    },
    fx = function(g, t) {

      var that = [],
        arr,
        f = {
          MultiLineString: 'LineString',
          LineString: 'Point',
          MultiPolygon: 'Polygon',
          Polygon: 'LinearRing',
          LinearRing: 'Point',
          MultiPoint: 'Point'
        };

      switch (t) {
        case 'Point':
          g = (g.get) ? g.get() : g;
          return ([g.lng(), g.lat()]);
          break;
        default:
          arr = g.getArray();
          for (var i = 0; i < arr.length; ++i) {
            that.push(fx(arr[i], f[t]));
          }
          if (t == 'LinearRing' &&
            that[0] !== that[that.length - 1]) {
            that.push([that[0][0], that[0][1]]);
          }
          return that;
      }
    };

    this.data.forEach(function(feature) {
      var _feature = {
          type: 'Feature',
          properties: {}
        },
        _id = feature.getId(),
        _geometry = feature.getGeometry(),
        _type = _geometry.getType(),
        _coordinates = fx(_geometry, _type);

      _feature.geometry = {
        type: _type,
        coordinates: _coordinates
      };
      if (typeof _id === 'string') {
        _feature.id = _id;
      }

      geo.features.push(_feature);
      feature.forEachProperty(function(v, k) {
        _feature.properties[k] = v;
      });
    });
    return geo;
  }

}


// WEBPACK FOOTER //
// ./src/plugin/mixins/GetGeojson.js